// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.chart-container[data-v-2b579d4c] {\n    position: relative;\n    height: 50vh;\n    width: 75vw;\n}\n", ""]);
// Exports
module.exports = exports;
